//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    tableClass: {
      type: String,
      default: 'table-desktop'
    },
    isComparison: {
      type: Boolean,
      default: false
    },
    m1PiEcus: Array,
    m1DiEcus: Array
  },
  computed: {
    colSpan () {
      let length = 0
      if (this.m1PiEcus) {
        length += this.m1PiEcus.length
      }
      if (this.m1DiEcus) {
        length += this.m1DiEcus.length
      }
      return length
    }
  }
}
